import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class DataserviceService {
  constructor(private http: HttpClient,) { }
  mapFilteredValues(data: any) {
    return data.map((item: any) => item.itemName) || []
  }
  mapOrder(listValues: any, selectedValues: any) {
    let newArray = []
    listValues = listValues.filter((elem: any) => !selectedValues.find(({ itemName }) => elem.itemName === itemName));
    newArray = newArray.concat(selectedValues)
    newArray = newArray.concat(listValues)
    return newArray
  };
  getMultiselectDropdownSettings(type = '') {
    let settings = {
      singleSelection: false,
      searchPlaceholderText: 'Select',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      badgeShowLimit: 2,
      noDataLabel: ''
    }
    if (type == 'nodata') {
      settings.noDataLabel = 'No data found'
      return settings
    } else if (type == 'loading') {
      settings.noDataLabel = 'Please wait while loading data...'
      return settings
    } else {
      return settings
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/customaggegatefringe/dataservice.service.ts